import React from 'react';
import { TabsContent } from '../../../components/ui/tabs';
import { Construction } from 'lucide-react';
import { MonthPeriodHeader } from '../../../components/common/MonthPeriodHeader';

export const TabForestaStub = ({ value, titulo, descripcion, periodo, setSelectedPeriodo }) => (
  <TabsContent value={value} className="mt-0">
    {setSelectedPeriodo && periodo && (
      <MonthPeriodHeader
        value={periodo}
        onChange={setSelectedPeriodo}
        testid={`foresta-header-${value}`}
      />
    )}
    <div className="bg-white border border-slate-200 rounded-lg p-12 text-center text-slate-500" data-testid={`stub-${value}`}>
      <Construction className="w-12 h-12 mx-auto text-slate-300 mb-3" />
      <h3 className="text-lg font-semibold text-slate-700 mb-2">{titulo}</h3>
      <p className="text-sm max-w-md mx-auto">{descripcion}</p>
      <p className="text-xs text-slate-400 mt-4">Esta pantalla se completa en una fase posterior. La estructura ya está bifurcada por modelo de administración.</p>
    </div>
  </TabsContent>
);

export default TabForestaStub;
